module.exports = __webpack_public_path__ + "img/Thai.3fb68ba9.svg";